import { FormsSetupType, StyleType } from ".";
import { PaymentusDefaultSetup } from "./components";
import { BraintreeDefaultSetup } from "./components/payment-processors/paypal-processor/const";
import { StripeDefaultSetup } from "./components/payment-processors/stripe-card-processor/components/stripe-elements/consts";
import { ProgressIndicatorColorOption } from "@ftdr/blueprint-components-react/lib/types/components/progress-indicator/progress-indicator.types";

export type CardProcessorType = "stripe";
export type AchProcessorType = "ach" | "achpaymentus";
export type PaypalProcessorType = "paypal";
export type PaymentsProcessorType =
  | CardProcessorType
  | PaypalProcessorType
  | "ach";
export type DisbursementProcessorType = "ach" | "paypal" | "check";
export type ResponseProcessorType =
  | PaymentsProcessorType
  | DisbursementProcessorType;
export type PaymentMethods = "CREDIT_CARD" | "BANK_ACCOUNT" | "PAYPAL";
export type DisbursementMethods = "ACH" | "PAYPAL" | "CHECK";
export type ResponseMethods = PaymentMethods | DisbursementMethods;
export type ACHMethods = "ACH" | "ACH_PAYMENTUS";
export type InputTypeName = "Input" | "MaskedInput";

export const PAYMENTS_METHODS: Record<PaymentMethods, PaymentMethods> = {
  CREDIT_CARD: "CREDIT_CARD",
  BANK_ACCOUNT: "BANK_ACCOUNT",
  PAYPAL: "PAYPAL",
};

export type AvailablePaymentMethods = Record<PaymentMethods, boolean>;

export const defaultAvailablePaymentMethods: AvailablePaymentMethods = {
  CREDIT_CARD: true,
  BANK_ACCOUNT: true,
  PAYPAL: false,
};

export const ACH_METHODS: Record<ACHMethods, AchProcessorType> = {
  ACH: "ach",
  ACH_PAYMENTUS: "achpaymentus",
};

export const INPUT_TYPE: Record<InputTypeName, InputTypeName> = {
  Input: "Input",
  MaskedInput: "MaskedInput",
};

export const PAYMENTS_MAP: Record<ResponseMethods, ResponseProcessorType> = {
  CREDIT_CARD: "stripe",
  PAYPAL: "paypal",
  BANK_ACCOUNT: "ach",
  ACH: "ach",
  CHECK: "check",
};

export const FormsSetupDefaultValue: FormsSetupType = {
  stripeForm: {
    mode: "onSubmit",
    reValidateMode: "onChange",
    fieldsSetup: StripeDefaultSetup,
  },
  paymentusForm: {
    mode: "onSubmit",
    reValidateMode: "onBlur",
    fieldsSetup: PaymentusDefaultSetup,
  },
  braintreeForm: {
    fieldsSetup: BraintreeDefaultSetup,
  },
};

export const BASE_PAYMENTUS_PRELOAD_PATHS = [
  { path: "", type: "document" },
  { path: "client-configuration-json.json", type: "application/json" },
  {
    path: "iframe-resizer-script/iframeResizer.contentWindow.min.js",
    type: "script",
  }, //remove this once we don't use iframeResizer anymore
];

export const progressIndicatorColorMap: Record<
  StyleType,
  ProgressIndicatorColorOption | undefined
> = {
  default: "primary",
  AHSRebrand: "interactive",
  HBW210: "interactive",
};
